import RestService from "@/services/RestService";

//https://stackoverflow.blog/2020/03/02/best-practices-for-rest-api-design/

function loginByEmail(email, password) {
  const data = {
    email,
    password,
  };
  return RestService.sendReq("post", "login", data);
}

export default {
  loginByEmail,
};
